var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/isarray/index.js
// module id = 1006
// module chunks = 2 3 4 5 6